
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1Zagj", function(module, exports) {
module.exports = $parcel$import("e1UzX").then(()=>parcelRequire('ckIH5'));

});

var $c614f0c3134ae559$exports = {};
$parcel$extendImportMap({
    "e1UzX": "copy.7a7003d2.js"
});

// packages/alpinejs/src/scheduler.js
var $4c8a6d2f80659ed7$var$flushPending = false;
var $4c8a6d2f80659ed7$var$flushing = false;
var $4c8a6d2f80659ed7$var$queue = [];
var $4c8a6d2f80659ed7$var$lastFlushedIndex = -1;
var $4c8a6d2f80659ed7$var$transactionActive = false;
function $4c8a6d2f80659ed7$var$scheduler(callback) {
    $4c8a6d2f80659ed7$var$queueJob(callback);
}
function $4c8a6d2f80659ed7$var$startTransaction() {
    $4c8a6d2f80659ed7$var$transactionActive = true;
}
function $4c8a6d2f80659ed7$var$commitTransaction() {
    $4c8a6d2f80659ed7$var$transactionActive = false;
    $4c8a6d2f80659ed7$var$queueFlush();
}
function $4c8a6d2f80659ed7$var$queueJob(job) {
    if (!$4c8a6d2f80659ed7$var$queue.includes(job)) $4c8a6d2f80659ed7$var$queue.push(job);
    $4c8a6d2f80659ed7$var$queueFlush();
}
function $4c8a6d2f80659ed7$var$dequeueJob(job) {
    let index = $4c8a6d2f80659ed7$var$queue.indexOf(job);
    if (index !== -1 && index > $4c8a6d2f80659ed7$var$lastFlushedIndex) $4c8a6d2f80659ed7$var$queue.splice(index, 1);
}
function $4c8a6d2f80659ed7$var$queueFlush() {
    if (!$4c8a6d2f80659ed7$var$flushing && !$4c8a6d2f80659ed7$var$flushPending) {
        if ($4c8a6d2f80659ed7$var$transactionActive) return;
        $4c8a6d2f80659ed7$var$flushPending = true;
        queueMicrotask($4c8a6d2f80659ed7$var$flushJobs);
    }
}
function $4c8a6d2f80659ed7$var$flushJobs() {
    $4c8a6d2f80659ed7$var$flushPending = false;
    $4c8a6d2f80659ed7$var$flushing = true;
    for(let i = 0; i < $4c8a6d2f80659ed7$var$queue.length; i++){
        $4c8a6d2f80659ed7$var$queue[i]();
        $4c8a6d2f80659ed7$var$lastFlushedIndex = i;
    }
    $4c8a6d2f80659ed7$var$queue.length = 0;
    $4c8a6d2f80659ed7$var$lastFlushedIndex = -1;
    $4c8a6d2f80659ed7$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $4c8a6d2f80659ed7$var$reactive;
var $4c8a6d2f80659ed7$var$effect;
var $4c8a6d2f80659ed7$var$release;
var $4c8a6d2f80659ed7$var$raw;
var $4c8a6d2f80659ed7$var$shouldSchedule = true;
function $4c8a6d2f80659ed7$var$disableEffectScheduling(callback) {
    $4c8a6d2f80659ed7$var$shouldSchedule = false;
    callback();
    $4c8a6d2f80659ed7$var$shouldSchedule = true;
}
function $4c8a6d2f80659ed7$var$setReactivityEngine(engine) {
    $4c8a6d2f80659ed7$var$reactive = engine.reactive;
    $4c8a6d2f80659ed7$var$release = engine.release;
    $4c8a6d2f80659ed7$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($4c8a6d2f80659ed7$var$shouldSchedule) $4c8a6d2f80659ed7$var$scheduler(task);
                else task();
            }
        });
    $4c8a6d2f80659ed7$var$raw = engine.raw;
}
function $4c8a6d2f80659ed7$var$overrideEffect(override) {
    $4c8a6d2f80659ed7$var$effect = override;
}
function $4c8a6d2f80659ed7$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $4c8a6d2f80659ed7$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $4c8a6d2f80659ed7$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $4c8a6d2f80659ed7$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $4c8a6d2f80659ed7$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        firstTime = false;
    });
    return ()=>$4c8a6d2f80659ed7$var$release(effectReference);
}
async function $4c8a6d2f80659ed7$var$transaction(callback) {
    $4c8a6d2f80659ed7$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $4c8a6d2f80659ed7$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $4c8a6d2f80659ed7$var$onAttributeAddeds = [];
var $4c8a6d2f80659ed7$var$onElRemoveds = [];
var $4c8a6d2f80659ed7$var$onElAddeds = [];
function $4c8a6d2f80659ed7$var$onElAdded(callback) {
    $4c8a6d2f80659ed7$var$onElAddeds.push(callback);
}
function $4c8a6d2f80659ed7$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $4c8a6d2f80659ed7$var$onElRemoveds.push(callback);
    }
}
function $4c8a6d2f80659ed7$var$onAttributesAdded(callback) {
    $4c8a6d2f80659ed7$var$onAttributeAddeds.push(callback);
}
function $4c8a6d2f80659ed7$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $4c8a6d2f80659ed7$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $4c8a6d2f80659ed7$var$cleanupElement(el) {
    el._x_effects?.forEach($4c8a6d2f80659ed7$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $4c8a6d2f80659ed7$var$observer = new MutationObserver($4c8a6d2f80659ed7$var$onMutate);
var $4c8a6d2f80659ed7$var$currentlyObserving = false;
function $4c8a6d2f80659ed7$var$startObservingMutations() {
    $4c8a6d2f80659ed7$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $4c8a6d2f80659ed7$var$currentlyObserving = true;
}
function $4c8a6d2f80659ed7$var$stopObservingMutations() {
    $4c8a6d2f80659ed7$var$flushObserver();
    $4c8a6d2f80659ed7$var$observer.disconnect();
    $4c8a6d2f80659ed7$var$currentlyObserving = false;
}
var $4c8a6d2f80659ed7$var$queuedMutations = [];
function $4c8a6d2f80659ed7$var$flushObserver() {
    let records = $4c8a6d2f80659ed7$var$observer.takeRecords();
    $4c8a6d2f80659ed7$var$queuedMutations.push(()=>records.length > 0 && $4c8a6d2f80659ed7$var$onMutate(records));
    let queueLengthWhenTriggered = $4c8a6d2f80659ed7$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($4c8a6d2f80659ed7$var$queuedMutations.length === queueLengthWhenTriggered) while($4c8a6d2f80659ed7$var$queuedMutations.length > 0)$4c8a6d2f80659ed7$var$queuedMutations.shift()();
    });
}
function $4c8a6d2f80659ed7$var$mutateDom(callback) {
    if (!$4c8a6d2f80659ed7$var$currentlyObserving) return callback();
    $4c8a6d2f80659ed7$var$stopObservingMutations();
    let result = callback();
    $4c8a6d2f80659ed7$var$startObservingMutations();
    return result;
}
var $4c8a6d2f80659ed7$var$isCollecting = false;
var $4c8a6d2f80659ed7$var$deferredMutations = [];
function $4c8a6d2f80659ed7$var$deferMutations() {
    $4c8a6d2f80659ed7$var$isCollecting = true;
}
function $4c8a6d2f80659ed7$var$flushAndStopDeferringMutations() {
    $4c8a6d2f80659ed7$var$isCollecting = false;
    $4c8a6d2f80659ed7$var$onMutate($4c8a6d2f80659ed7$var$deferredMutations);
    $4c8a6d2f80659ed7$var$deferredMutations = [];
}
function $4c8a6d2f80659ed7$var$onMutate(mutations) {
    if ($4c8a6d2f80659ed7$var$isCollecting) {
        $4c8a6d2f80659ed7$var$deferredMutations = $4c8a6d2f80659ed7$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $4c8a6d2f80659ed7$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $4c8a6d2f80659ed7$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $4c8a6d2f80659ed7$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $4c8a6d2f80659ed7$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $4c8a6d2f80659ed7$var$scope(node) {
    return $4c8a6d2f80659ed7$var$mergeProxies($4c8a6d2f80659ed7$var$closestDataStack(node));
}
function $4c8a6d2f80659ed7$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$4c8a6d2f80659ed7$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $4c8a6d2f80659ed7$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $4c8a6d2f80659ed7$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $4c8a6d2f80659ed7$var$closestDataStack(node.parentNode);
}
function $4c8a6d2f80659ed7$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $4c8a6d2f80659ed7$var$mergeProxyTrap);
}
var $4c8a6d2f80659ed7$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $4c8a6d2f80659ed7$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $4c8a6d2f80659ed7$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $4c8a6d2f80659ed7$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $4c8a6d2f80659ed7$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$4c8a6d2f80659ed7$var$get(data2, path), (value)=>$4c8a6d2f80659ed7$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $4c8a6d2f80659ed7$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $4c8a6d2f80659ed7$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $4c8a6d2f80659ed7$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $4c8a6d2f80659ed7$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $4c8a6d2f80659ed7$var$magics = {};
function $4c8a6d2f80659ed7$var$magic(name, callback) {
    $4c8a6d2f80659ed7$var$magics[name] = callback;
}
function $4c8a6d2f80659ed7$var$injectMagics(obj, el) {
    let memoizedUtilities = $4c8a6d2f80659ed7$var$getUtilities(el);
    Object.entries($4c8a6d2f80659ed7$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $4c8a6d2f80659ed7$var$getUtilities(el) {
    let [utilities, cleanup2] = $4c8a6d2f80659ed7$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $4c8a6d2f80659ed7$var$interceptor,
        ...utilities
    };
    $4c8a6d2f80659ed7$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $4c8a6d2f80659ed7$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $4c8a6d2f80659ed7$var$handleError(e, el, expression);
    }
}
function $4c8a6d2f80659ed7$var$handleError(...args) {
    return $4c8a6d2f80659ed7$var$errorHandler(...args);
}
var $4c8a6d2f80659ed7$var$errorHandler = $4c8a6d2f80659ed7$var$normalErrorHandler;
function $4c8a6d2f80659ed7$var$setErrorHandler(handler4) {
    $4c8a6d2f80659ed7$var$errorHandler = handler4;
}
function $4c8a6d2f80659ed7$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions = true;
function $4c8a6d2f80659ed7$var$dontAutoEvaluateFunctions(callback) {
    let cache = $4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions;
    $4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $4c8a6d2f80659ed7$var$evaluate(el, expression, extras = {}) {
    let result;
    $4c8a6d2f80659ed7$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $4c8a6d2f80659ed7$var$evaluateLater(...args) {
    return $4c8a6d2f80659ed7$var$theEvaluatorFunction(...args);
}
var $4c8a6d2f80659ed7$var$theEvaluatorFunction = $4c8a6d2f80659ed7$var$normalEvaluator;
function $4c8a6d2f80659ed7$var$setEvaluator(newEvaluator) {
    $4c8a6d2f80659ed7$var$theEvaluatorFunction = newEvaluator;
}
var $4c8a6d2f80659ed7$var$theRawEvaluatorFunction;
function $4c8a6d2f80659ed7$var$setRawEvaluator(newEvaluator) {
    $4c8a6d2f80659ed7$var$theRawEvaluatorFunction = newEvaluator;
}
function $4c8a6d2f80659ed7$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $4c8a6d2f80659ed7$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$4c8a6d2f80659ed7$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $4c8a6d2f80659ed7$var$generateEvaluatorFromFunction(dataStack, expression) : $4c8a6d2f80659ed7$var$generateEvaluatorFromString(dataStack, expression, el);
    return $4c8a6d2f80659ed7$var$tryCatch.bind(null, el, expression, evaluator);
}
function $4c8a6d2f80659ed7$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions) {
            $4c8a6d2f80659ed7$var$runIfTypeOfFunction(receiver, func, $4c8a6d2f80659ed7$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($4c8a6d2f80659ed7$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $4c8a6d2f80659ed7$var$runIfTypeOfFunction(receiver, result);
    };
}
var $4c8a6d2f80659ed7$var$evaluatorMemo = {};
function $4c8a6d2f80659ed7$var$generateFunctionFromString(expression, el) {
    if ($4c8a6d2f80659ed7$var$evaluatorMemo[expression]) return $4c8a6d2f80659ed7$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $4c8a6d2f80659ed7$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $4c8a6d2f80659ed7$var$evaluatorMemo[expression] = func;
    return func;
}
function $4c8a6d2f80659ed7$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $4c8a6d2f80659ed7$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $4c8a6d2f80659ed7$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$4c8a6d2f80659ed7$var$handleError(error2, el, expression));
            if (func.finished) {
                $4c8a6d2f80659ed7$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $4c8a6d2f80659ed7$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$4c8a6d2f80659ed7$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $4c8a6d2f80659ed7$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$4c8a6d2f80659ed7$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$4c8a6d2f80659ed7$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $4c8a6d2f80659ed7$var$evaluateRaw(...args) {
    return $4c8a6d2f80659ed7$var$theRawEvaluatorFunction(...args);
}
function $4c8a6d2f80659ed7$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $4c8a6d2f80659ed7$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$4c8a6d2f80659ed7$var$closestDataStack(el)
    ];
    let scope2 = $4c8a6d2f80659ed7$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $4c8a6d2f80659ed7$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $4c8a6d2f80659ed7$var$prefixAsString = "x-";
function $4c8a6d2f80659ed7$var$prefix(subject = "") {
    return $4c8a6d2f80659ed7$var$prefixAsString + subject;
}
function $4c8a6d2f80659ed7$var$setPrefix(newPrefix) {
    $4c8a6d2f80659ed7$var$prefixAsString = newPrefix;
}
var $4c8a6d2f80659ed7$var$directiveHandlers = {};
function $4c8a6d2f80659ed7$var$directive(name, callback) {
    $4c8a6d2f80659ed7$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$4c8a6d2f80659ed7$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $4c8a6d2f80659ed7$var$directiveOrder.indexOf(directive2);
            $4c8a6d2f80659ed7$var$directiveOrder.splice(pos >= 0 ? pos : $4c8a6d2f80659ed7$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $4c8a6d2f80659ed7$var$directiveExists(name) {
    return Object.keys($4c8a6d2f80659ed7$var$directiveHandlers).includes(name);
}
function $4c8a6d2f80659ed7$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $4c8a6d2f80659ed7$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($4c8a6d2f80659ed7$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($4c8a6d2f80659ed7$var$outNonAlpineAttributes).map($4c8a6d2f80659ed7$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($4c8a6d2f80659ed7$var$byPriority);
    return directives2.map((directive2)=>{
        return $4c8a6d2f80659ed7$var$getDirectiveHandler(el, directive2);
    });
}
function $4c8a6d2f80659ed7$var$attributesOnly(attributes) {
    return Array.from(attributes).map($4c8a6d2f80659ed7$var$toTransformedAttributes()).filter((attr)=>!$4c8a6d2f80659ed7$var$outNonAlpineAttributes(attr));
}
var $4c8a6d2f80659ed7$var$isDeferringHandlers = false;
var $4c8a6d2f80659ed7$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $4c8a6d2f80659ed7$var$currentHandlerStackKey = Symbol();
function $4c8a6d2f80659ed7$var$deferHandlingDirectives(callback) {
    $4c8a6d2f80659ed7$var$isDeferringHandlers = true;
    let key = Symbol();
    $4c8a6d2f80659ed7$var$currentHandlerStackKey = key;
    $4c8a6d2f80659ed7$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($4c8a6d2f80659ed7$var$directiveHandlerStacks.get(key).length)$4c8a6d2f80659ed7$var$directiveHandlerStacks.get(key).shift()();
        $4c8a6d2f80659ed7$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $4c8a6d2f80659ed7$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $4c8a6d2f80659ed7$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $4c8a6d2f80659ed7$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $4c8a6d2f80659ed7$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $4c8a6d2f80659ed7$var$evaluateLater.bind($4c8a6d2f80659ed7$var$evaluateLater, el),
        evaluate: $4c8a6d2f80659ed7$var$evaluate.bind($4c8a6d2f80659ed7$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $4c8a6d2f80659ed7$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $4c8a6d2f80659ed7$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $4c8a6d2f80659ed7$var$getElementBoundUtilities(el);
    $4c8a6d2f80659ed7$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $4c8a6d2f80659ed7$var$isDeferringHandlers ? $4c8a6d2f80659ed7$var$directiveHandlerStacks.get($4c8a6d2f80659ed7$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $4c8a6d2f80659ed7$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $4c8a6d2f80659ed7$var$into = (i)=>i;
function $4c8a6d2f80659ed7$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $4c8a6d2f80659ed7$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $4c8a6d2f80659ed7$var$attributeTransformers = [];
function $4c8a6d2f80659ed7$var$mapAttributes(callback) {
    $4c8a6d2f80659ed7$var$attributeTransformers.push(callback);
}
function $4c8a6d2f80659ed7$var$outNonAlpineAttributes({ name: name }) {
    return $4c8a6d2f80659ed7$var$alpineAttributeRegex().test(name);
}
var $4c8a6d2f80659ed7$var$alpineAttributeRegex = ()=>new RegExp(`^${$4c8a6d2f80659ed7$var$prefixAsString}([^:^.]+)\\b`);
function $4c8a6d2f80659ed7$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($4c8a6d2f80659ed7$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $4c8a6d2f80659ed7$var$DEFAULT = "DEFAULT";
var $4c8a6d2f80659ed7$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $4c8a6d2f80659ed7$var$DEFAULT,
    "teleport"
];
function $4c8a6d2f80659ed7$var$byPriority(a, b) {
    let typeA = $4c8a6d2f80659ed7$var$directiveOrder.indexOf(a.type) === -1 ? $4c8a6d2f80659ed7$var$DEFAULT : a.type;
    let typeB = $4c8a6d2f80659ed7$var$directiveOrder.indexOf(b.type) === -1 ? $4c8a6d2f80659ed7$var$DEFAULT : b.type;
    return $4c8a6d2f80659ed7$var$directiveOrder.indexOf(typeA) - $4c8a6d2f80659ed7$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $4c8a6d2f80659ed7$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $4c8a6d2f80659ed7$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$4c8a6d2f80659ed7$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $4c8a6d2f80659ed7$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $4c8a6d2f80659ed7$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $4c8a6d2f80659ed7$var$started = false;
function $4c8a6d2f80659ed7$var$start() {
    if ($4c8a6d2f80659ed7$var$started) $4c8a6d2f80659ed7$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $4c8a6d2f80659ed7$var$started = true;
    if (!document.body) $4c8a6d2f80659ed7$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $4c8a6d2f80659ed7$var$dispatch(document, "alpine:init");
    $4c8a6d2f80659ed7$var$dispatch(document, "alpine:initializing");
    $4c8a6d2f80659ed7$var$startObservingMutations();
    $4c8a6d2f80659ed7$var$onElAdded((el)=>$4c8a6d2f80659ed7$var$initTree(el, $4c8a6d2f80659ed7$var$walk));
    $4c8a6d2f80659ed7$var$onElRemoved((el)=>$4c8a6d2f80659ed7$var$destroyTree(el));
    $4c8a6d2f80659ed7$var$onAttributesAdded((el, attrs)=>{
        $4c8a6d2f80659ed7$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$4c8a6d2f80659ed7$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($4c8a6d2f80659ed7$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $4c8a6d2f80659ed7$var$initTree(el);
    });
    $4c8a6d2f80659ed7$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $4c8a6d2f80659ed7$var$warnAboutMissingPlugins();
    });
}
var $4c8a6d2f80659ed7$var$rootSelectorCallbacks = [];
var $4c8a6d2f80659ed7$var$initSelectorCallbacks = [];
function $4c8a6d2f80659ed7$var$rootSelectors() {
    return $4c8a6d2f80659ed7$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $4c8a6d2f80659ed7$var$allSelectors() {
    return $4c8a6d2f80659ed7$var$rootSelectorCallbacks.concat($4c8a6d2f80659ed7$var$initSelectorCallbacks).map((fn)=>fn());
}
function $4c8a6d2f80659ed7$var$addRootSelector(selectorCallback) {
    $4c8a6d2f80659ed7$var$rootSelectorCallbacks.push(selectorCallback);
}
function $4c8a6d2f80659ed7$var$addInitSelector(selectorCallback) {
    $4c8a6d2f80659ed7$var$initSelectorCallbacks.push(selectorCallback);
}
function $4c8a6d2f80659ed7$var$closestRoot(el, includeInitSelectors = false) {
    return $4c8a6d2f80659ed7$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $4c8a6d2f80659ed7$var$allSelectors() : $4c8a6d2f80659ed7$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $4c8a6d2f80659ed7$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $4c8a6d2f80659ed7$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $4c8a6d2f80659ed7$var$findClosest(el.parentElement, callback);
}
function $4c8a6d2f80659ed7$var$isRoot(el) {
    return $4c8a6d2f80659ed7$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $4c8a6d2f80659ed7$var$initInterceptors2 = [];
function $4c8a6d2f80659ed7$var$interceptInit(callback) {
    $4c8a6d2f80659ed7$var$initInterceptors2.push(callback);
}
var $4c8a6d2f80659ed7$var$markerDispenser = 1;
function $4c8a6d2f80659ed7$var$initTree(el, walker = $4c8a6d2f80659ed7$var$walk, intercept = ()=>{}) {
    if ($4c8a6d2f80659ed7$var$findClosest(el, (i)=>i._x_ignore)) return;
    $4c8a6d2f80659ed7$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $4c8a6d2f80659ed7$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $4c8a6d2f80659ed7$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $4c8a6d2f80659ed7$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $4c8a6d2f80659ed7$var$destroyTree(root, walker = $4c8a6d2f80659ed7$var$walk) {
    walker(root, (el)=>{
        $4c8a6d2f80659ed7$var$cleanupElement(el);
        $4c8a6d2f80659ed7$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $4c8a6d2f80659ed7$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($4c8a6d2f80659ed7$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $4c8a6d2f80659ed7$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $4c8a6d2f80659ed7$var$tickStack = [];
var $4c8a6d2f80659ed7$var$isHolding = false;
function $4c8a6d2f80659ed7$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $4c8a6d2f80659ed7$var$isHolding || setTimeout(()=>{
            $4c8a6d2f80659ed7$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $4c8a6d2f80659ed7$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $4c8a6d2f80659ed7$var$releaseNextTicks() {
    $4c8a6d2f80659ed7$var$isHolding = false;
    while($4c8a6d2f80659ed7$var$tickStack.length)$4c8a6d2f80659ed7$var$tickStack.shift()();
}
function $4c8a6d2f80659ed7$var$holdNextTicks() {
    $4c8a6d2f80659ed7$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $4c8a6d2f80659ed7$var$setClasses(el, value) {
    if (Array.isArray(value)) return $4c8a6d2f80659ed7$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $4c8a6d2f80659ed7$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $4c8a6d2f80659ed7$var$setClasses(el, value());
    return $4c8a6d2f80659ed7$var$setClassesFromString(el, value);
}
function $4c8a6d2f80659ed7$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $4c8a6d2f80659ed7$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $4c8a6d2f80659ed7$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $4c8a6d2f80659ed7$var$setStylesFromObject(el, value);
    return $4c8a6d2f80659ed7$var$setStylesFromString(el, value);
}
function $4c8a6d2f80659ed7$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $4c8a6d2f80659ed7$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $4c8a6d2f80659ed7$var$setStyles(el, previousStyles);
    };
}
function $4c8a6d2f80659ed7$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $4c8a6d2f80659ed7$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $4c8a6d2f80659ed7$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$4c8a6d2f80659ed7$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $4c8a6d2f80659ed7$var$registerTransitionsFromHelper(el, modifiers, value);
    else $4c8a6d2f80659ed7$var$registerTransitionsFromClassString(el, expression, value);
});
function $4c8a6d2f80659ed7$var$registerTransitionsFromClassString(el, classString, stage) {
    $4c8a6d2f80659ed7$var$registerTransitionObject(el, $4c8a6d2f80659ed7$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $4c8a6d2f80659ed7$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $4c8a6d2f80659ed7$var$registerTransitionObject(el, $4c8a6d2f80659ed7$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $4c8a6d2f80659ed7$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $4c8a6d2f80659ed7$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $4c8a6d2f80659ed7$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $4c8a6d2f80659ed7$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $4c8a6d2f80659ed7$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $4c8a6d2f80659ed7$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $4c8a6d2f80659ed7$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $4c8a6d2f80659ed7$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $4c8a6d2f80659ed7$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $4c8a6d2f80659ed7$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $4c8a6d2f80659ed7$var$closestHide(parent);
}
function $4c8a6d2f80659ed7$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $4c8a6d2f80659ed7$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $4c8a6d2f80659ed7$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $4c8a6d2f80659ed7$var$once(()=>{
        $4c8a6d2f80659ed7$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $4c8a6d2f80659ed7$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $4c8a6d2f80659ed7$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $4c8a6d2f80659ed7$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $4c8a6d2f80659ed7$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $4c8a6d2f80659ed7$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                stages.end();
            });
            $4c8a6d2f80659ed7$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $4c8a6d2f80659ed7$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $4c8a6d2f80659ed7$var$isCloning = false;
function $4c8a6d2f80659ed7$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$4c8a6d2f80659ed7$var$isCloning ? fallback(...args) : callback(...args);
}
function $4c8a6d2f80659ed7$var$onlyDuringClone(callback) {
    return (...args)=>$4c8a6d2f80659ed7$var$isCloning && callback(...args);
}
var $4c8a6d2f80659ed7$var$interceptors = [];
function $4c8a6d2f80659ed7$var$interceptClone(callback) {
    $4c8a6d2f80659ed7$var$interceptors.push(callback);
}
function $4c8a6d2f80659ed7$var$cloneNode(from, to) {
    $4c8a6d2f80659ed7$var$interceptors.forEach((i)=>i(from, to));
    $4c8a6d2f80659ed7$var$isCloning = true;
    $4c8a6d2f80659ed7$var$dontRegisterReactiveSideEffects(()=>{
        $4c8a6d2f80659ed7$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $4c8a6d2f80659ed7$var$isCloning = false;
}
var $4c8a6d2f80659ed7$var$isCloningLegacy = false;
function $4c8a6d2f80659ed7$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $4c8a6d2f80659ed7$var$isCloning = true;
    $4c8a6d2f80659ed7$var$isCloningLegacy = true;
    $4c8a6d2f80659ed7$var$dontRegisterReactiveSideEffects(()=>{
        $4c8a6d2f80659ed7$var$cloneTree(newEl);
    });
    $4c8a6d2f80659ed7$var$isCloning = false;
    $4c8a6d2f80659ed7$var$isCloningLegacy = false;
}
function $4c8a6d2f80659ed7$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $4c8a6d2f80659ed7$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $4c8a6d2f80659ed7$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $4c8a6d2f80659ed7$var$initTree(el, shallowWalker);
}
function $4c8a6d2f80659ed7$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $4c8a6d2f80659ed7$var$effect;
    $4c8a6d2f80659ed7$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $4c8a6d2f80659ed7$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $4c8a6d2f80659ed7$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $4c8a6d2f80659ed7$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $4c8a6d2f80659ed7$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $4c8a6d2f80659ed7$var$camelCase(name) : name;
    switch(name){
        case "value":
            $4c8a6d2f80659ed7$var$bindInputValue(el, value);
            break;
        case "style":
            $4c8a6d2f80659ed7$var$bindStyles(el, value);
            break;
        case "class":
            $4c8a6d2f80659ed7$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $4c8a6d2f80659ed7$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $4c8a6d2f80659ed7$var$bindAttribute(el, name, value);
            break;
    }
}
function $4c8a6d2f80659ed7$var$bindInputValue(el, value) {
    if ($4c8a6d2f80659ed7$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $4c8a6d2f80659ed7$var$safeParseBoolean(el.value) === value;
            else el.checked = $4c8a6d2f80659ed7$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($4c8a6d2f80659ed7$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$4c8a6d2f80659ed7$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $4c8a6d2f80659ed7$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $4c8a6d2f80659ed7$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $4c8a6d2f80659ed7$var$setClasses(el, value);
}
function $4c8a6d2f80659ed7$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $4c8a6d2f80659ed7$var$setStyles(el, value);
}
function $4c8a6d2f80659ed7$var$bindAttributeAndProperty(el, name, value) {
    $4c8a6d2f80659ed7$var$bindAttribute(el, name, value);
    $4c8a6d2f80659ed7$var$setPropertyIfChanged(el, name, value);
}
function $4c8a6d2f80659ed7$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $4c8a6d2f80659ed7$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($4c8a6d2f80659ed7$var$isBooleanAttr(name)) value = name;
        $4c8a6d2f80659ed7$var$setIfChanged(el, name, value);
    }
}
function $4c8a6d2f80659ed7$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $4c8a6d2f80659ed7$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $4c8a6d2f80659ed7$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $4c8a6d2f80659ed7$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $4c8a6d2f80659ed7$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $4c8a6d2f80659ed7$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $4c8a6d2f80659ed7$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $4c8a6d2f80659ed7$var$isBooleanAttr(attrName) {
    return $4c8a6d2f80659ed7$var$booleanAttributes.has(attrName);
}
function $4c8a6d2f80659ed7$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $4c8a6d2f80659ed7$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $4c8a6d2f80659ed7$var$getAttributeBinding(el, name, fallback);
}
function $4c8a6d2f80659ed7$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $4c8a6d2f80659ed7$var$dontAutoEvaluateFunctions(()=>{
            return $4c8a6d2f80659ed7$var$evaluate(el, binding.expression);
        });
    }
    return $4c8a6d2f80659ed7$var$getAttributeBinding(el, name, fallback);
}
function $4c8a6d2f80659ed7$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($4c8a6d2f80659ed7$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $4c8a6d2f80659ed7$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $4c8a6d2f80659ed7$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $4c8a6d2f80659ed7$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $4c8a6d2f80659ed7$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $4c8a6d2f80659ed7$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $4c8a6d2f80659ed7$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($4c8a6d2f80659ed7$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($4c8a6d2f80659ed7$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($4c8a6d2f80659ed7$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $4c8a6d2f80659ed7$var$release(reference);
    };
}
function $4c8a6d2f80659ed7$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $4c8a6d2f80659ed7$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($4c8a6d2f80659ed7$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $4c8a6d2f80659ed7$var$stores = {};
var $4c8a6d2f80659ed7$var$isReactive = false;
function $4c8a6d2f80659ed7$var$store(name, value) {
    if (!$4c8a6d2f80659ed7$var$isReactive) {
        $4c8a6d2f80659ed7$var$stores = $4c8a6d2f80659ed7$var$reactive($4c8a6d2f80659ed7$var$stores);
        $4c8a6d2f80659ed7$var$isReactive = true;
    }
    if (value === void 0) return $4c8a6d2f80659ed7$var$stores[name];
    $4c8a6d2f80659ed7$var$stores[name] = value;
    $4c8a6d2f80659ed7$var$initInterceptors($4c8a6d2f80659ed7$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $4c8a6d2f80659ed7$var$stores[name].init();
}
function $4c8a6d2f80659ed7$var$getStores() {
    return $4c8a6d2f80659ed7$var$stores;
}
// packages/alpinejs/src/binds.js
var $4c8a6d2f80659ed7$var$binds = {};
function $4c8a6d2f80659ed7$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $4c8a6d2f80659ed7$var$applyBindingsObject(name, getBindings());
    else $4c8a6d2f80659ed7$var$binds[name] = getBindings;
    return ()=>{};
}
function $4c8a6d2f80659ed7$var$injectBindingProviders(obj) {
    Object.entries($4c8a6d2f80659ed7$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $4c8a6d2f80659ed7$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $4c8a6d2f80659ed7$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $4c8a6d2f80659ed7$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $4c8a6d2f80659ed7$var$datas = {};
function $4c8a6d2f80659ed7$var$data(name, callback) {
    $4c8a6d2f80659ed7$var$datas[name] = callback;
}
function $4c8a6d2f80659ed7$var$injectDataProviders(obj, context) {
    Object.entries($4c8a6d2f80659ed7$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $4c8a6d2f80659ed7$var$Alpine = {
    get reactive () {
        return $4c8a6d2f80659ed7$var$reactive;
    },
    get release () {
        return $4c8a6d2f80659ed7$var$release;
    },
    get effect () {
        return $4c8a6d2f80659ed7$var$effect;
    },
    get raw () {
        return $4c8a6d2f80659ed7$var$raw;
    },
    get transaction () {
        return $4c8a6d2f80659ed7$var$transaction;
    },
    version: "3.15.8",
    flushAndStopDeferringMutations: $4c8a6d2f80659ed7$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $4c8a6d2f80659ed7$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $4c8a6d2f80659ed7$var$disableEffectScheduling,
    startObservingMutations: $4c8a6d2f80659ed7$var$startObservingMutations,
    stopObservingMutations: $4c8a6d2f80659ed7$var$stopObservingMutations,
    setReactivityEngine: $4c8a6d2f80659ed7$var$setReactivityEngine,
    onAttributeRemoved: $4c8a6d2f80659ed7$var$onAttributeRemoved,
    onAttributesAdded: $4c8a6d2f80659ed7$var$onAttributesAdded,
    closestDataStack: $4c8a6d2f80659ed7$var$closestDataStack,
    skipDuringClone: $4c8a6d2f80659ed7$var$skipDuringClone,
    onlyDuringClone: $4c8a6d2f80659ed7$var$onlyDuringClone,
    addRootSelector: $4c8a6d2f80659ed7$var$addRootSelector,
    addInitSelector: $4c8a6d2f80659ed7$var$addInitSelector,
    setErrorHandler: $4c8a6d2f80659ed7$var$setErrorHandler,
    interceptClone: $4c8a6d2f80659ed7$var$interceptClone,
    addScopeToNode: $4c8a6d2f80659ed7$var$addScopeToNode,
    deferMutations: $4c8a6d2f80659ed7$var$deferMutations,
    mapAttributes: $4c8a6d2f80659ed7$var$mapAttributes,
    evaluateLater: $4c8a6d2f80659ed7$var$evaluateLater,
    interceptInit: $4c8a6d2f80659ed7$var$interceptInit,
    initInterceptors: $4c8a6d2f80659ed7$var$initInterceptors,
    injectMagics: $4c8a6d2f80659ed7$var$injectMagics,
    setEvaluator: $4c8a6d2f80659ed7$var$setEvaluator,
    setRawEvaluator: $4c8a6d2f80659ed7$var$setRawEvaluator,
    mergeProxies: $4c8a6d2f80659ed7$var$mergeProxies,
    extractProp: $4c8a6d2f80659ed7$var$extractProp,
    findClosest: $4c8a6d2f80659ed7$var$findClosest,
    onElRemoved: $4c8a6d2f80659ed7$var$onElRemoved,
    closestRoot: $4c8a6d2f80659ed7$var$closestRoot,
    destroyTree: $4c8a6d2f80659ed7$var$destroyTree,
    interceptor: $4c8a6d2f80659ed7$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $4c8a6d2f80659ed7$var$transition,
    setStyles: // INTERNAL
    $4c8a6d2f80659ed7$var$setStyles,
    mutateDom: // INTERNAL
    $4c8a6d2f80659ed7$var$mutateDom,
    directive: $4c8a6d2f80659ed7$var$directive,
    entangle: $4c8a6d2f80659ed7$var$entangle,
    throttle: $4c8a6d2f80659ed7$var$throttle,
    debounce: $4c8a6d2f80659ed7$var$debounce,
    evaluate: $4c8a6d2f80659ed7$var$evaluate,
    evaluateRaw: $4c8a6d2f80659ed7$var$evaluateRaw,
    initTree: $4c8a6d2f80659ed7$var$initTree,
    nextTick: $4c8a6d2f80659ed7$var$nextTick,
    prefixed: $4c8a6d2f80659ed7$var$prefix,
    prefix: $4c8a6d2f80659ed7$var$setPrefix,
    plugin: $4c8a6d2f80659ed7$var$plugin,
    magic: $4c8a6d2f80659ed7$var$magic,
    store: $4c8a6d2f80659ed7$var$store,
    start: $4c8a6d2f80659ed7$var$start,
    clone: $4c8a6d2f80659ed7$var$clone,
    cloneNode: // INTERNAL
    $4c8a6d2f80659ed7$var$cloneNode,
    // INTERNAL
    bound: $4c8a6d2f80659ed7$var$getBinding,
    $data: $4c8a6d2f80659ed7$var$scope,
    watch: $4c8a6d2f80659ed7$var$watch,
    walk: $4c8a6d2f80659ed7$var$walk,
    data: $4c8a6d2f80659ed7$var$data,
    bind: $4c8a6d2f80659ed7$var$bind2
};
var $4c8a6d2f80659ed7$var$alpine_default = $4c8a6d2f80659ed7$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $4c8a6d2f80659ed7$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $4c8a6d2f80659ed7$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $4c8a6d2f80659ed7$var$isBooleanAttr2 = /* @__PURE__ */ $4c8a6d2f80659ed7$var$makeMap($4c8a6d2f80659ed7$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $4c8a6d2f80659ed7$var$EMPTY_OBJ = Object.freeze({});
var $4c8a6d2f80659ed7$var$EMPTY_ARR = Object.freeze([]);
var $4c8a6d2f80659ed7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4c8a6d2f80659ed7$var$hasOwn = (val, key)=>$4c8a6d2f80659ed7$var$hasOwnProperty.call(val, key);
var $4c8a6d2f80659ed7$var$isArray = Array.isArray;
var $4c8a6d2f80659ed7$var$isMap = (val)=>$4c8a6d2f80659ed7$var$toTypeString(val) === "[object Map]";
var $4c8a6d2f80659ed7$var$isString = (val)=>typeof val === "string";
var $4c8a6d2f80659ed7$var$isSymbol = (val)=>typeof val === "symbol";
var $4c8a6d2f80659ed7$var$isObject = (val)=>val !== null && typeof val === "object";
var $4c8a6d2f80659ed7$var$objectToString = Object.prototype.toString;
var $4c8a6d2f80659ed7$var$toTypeString = (value)=>$4c8a6d2f80659ed7$var$objectToString.call(value);
var $4c8a6d2f80659ed7$var$toRawType = (value)=>{
    return $4c8a6d2f80659ed7$var$toTypeString(value).slice(8, -1);
};
var $4c8a6d2f80659ed7$var$isIntegerKey = (key)=>$4c8a6d2f80659ed7$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $4c8a6d2f80659ed7$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $4c8a6d2f80659ed7$var$camelizeRE = /-(\w)/g;
var $4c8a6d2f80659ed7$var$camelize = $4c8a6d2f80659ed7$var$cacheStringFunction((str)=>{
    return str.replace($4c8a6d2f80659ed7$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $4c8a6d2f80659ed7$var$hyphenateRE = /\B([A-Z])/g;
var $4c8a6d2f80659ed7$var$hyphenate = $4c8a6d2f80659ed7$var$cacheStringFunction((str)=>str.replace($4c8a6d2f80659ed7$var$hyphenateRE, "-$1").toLowerCase());
var $4c8a6d2f80659ed7$var$capitalize = $4c8a6d2f80659ed7$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $4c8a6d2f80659ed7$var$toHandlerKey = $4c8a6d2f80659ed7$var$cacheStringFunction((str)=>str ? `on${$4c8a6d2f80659ed7$var$capitalize(str)}` : ``);
var $4c8a6d2f80659ed7$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $4c8a6d2f80659ed7$var$targetMap = /* @__PURE__ */ new WeakMap();
var $4c8a6d2f80659ed7$var$effectStack = [];
var $4c8a6d2f80659ed7$var$activeEffect;
var $4c8a6d2f80659ed7$var$ITERATE_KEY = Symbol("iterate");
var $4c8a6d2f80659ed7$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $4c8a6d2f80659ed7$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $4c8a6d2f80659ed7$var$effect2(fn, options = $4c8a6d2f80659ed7$var$EMPTY_OBJ) {
    if ($4c8a6d2f80659ed7$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $4c8a6d2f80659ed7$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $4c8a6d2f80659ed7$var$stop(effect3) {
    if (effect3.active) {
        $4c8a6d2f80659ed7$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $4c8a6d2f80659ed7$var$uid = 0;
function $4c8a6d2f80659ed7$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$4c8a6d2f80659ed7$var$effectStack.includes(effect3)) {
            $4c8a6d2f80659ed7$var$cleanup(effect3);
            try {
                $4c8a6d2f80659ed7$var$enableTracking();
                $4c8a6d2f80659ed7$var$effectStack.push(effect3);
                $4c8a6d2f80659ed7$var$activeEffect = effect3;
                return fn();
            } finally{
                $4c8a6d2f80659ed7$var$effectStack.pop();
                $4c8a6d2f80659ed7$var$resetTracking();
                $4c8a6d2f80659ed7$var$activeEffect = $4c8a6d2f80659ed7$var$effectStack[$4c8a6d2f80659ed7$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $4c8a6d2f80659ed7$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $4c8a6d2f80659ed7$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $4c8a6d2f80659ed7$var$shouldTrack = true;
var $4c8a6d2f80659ed7$var$trackStack = [];
function $4c8a6d2f80659ed7$var$pauseTracking() {
    $4c8a6d2f80659ed7$var$trackStack.push($4c8a6d2f80659ed7$var$shouldTrack);
    $4c8a6d2f80659ed7$var$shouldTrack = false;
}
function $4c8a6d2f80659ed7$var$enableTracking() {
    $4c8a6d2f80659ed7$var$trackStack.push($4c8a6d2f80659ed7$var$shouldTrack);
    $4c8a6d2f80659ed7$var$shouldTrack = true;
}
function $4c8a6d2f80659ed7$var$resetTracking() {
    const last = $4c8a6d2f80659ed7$var$trackStack.pop();
    $4c8a6d2f80659ed7$var$shouldTrack = last === void 0 ? true : last;
}
function $4c8a6d2f80659ed7$var$track(target, type, key) {
    if (!$4c8a6d2f80659ed7$var$shouldTrack || $4c8a6d2f80659ed7$var$activeEffect === void 0) return;
    let depsMap = $4c8a6d2f80659ed7$var$targetMap.get(target);
    if (!depsMap) $4c8a6d2f80659ed7$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($4c8a6d2f80659ed7$var$activeEffect)) {
        dep.add($4c8a6d2f80659ed7$var$activeEffect);
        $4c8a6d2f80659ed7$var$activeEffect.deps.push(dep);
        if ($4c8a6d2f80659ed7$var$activeEffect.options.onTrack) $4c8a6d2f80659ed7$var$activeEffect.options.onTrack({
            effect: $4c8a6d2f80659ed7$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $4c8a6d2f80659ed7$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $4c8a6d2f80659ed7$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $4c8a6d2f80659ed7$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $4c8a6d2f80659ed7$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$4c8a6d2f80659ed7$var$isArray(target)) {
                    add2(depsMap.get($4c8a6d2f80659ed7$var$ITERATE_KEY));
                    if ($4c8a6d2f80659ed7$var$isMap(target)) add2(depsMap.get($4c8a6d2f80659ed7$var$MAP_KEY_ITERATE_KEY));
                } else if ($4c8a6d2f80659ed7$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$4c8a6d2f80659ed7$var$isArray(target)) {
                    add2(depsMap.get($4c8a6d2f80659ed7$var$ITERATE_KEY));
                    if ($4c8a6d2f80659ed7$var$isMap(target)) add2(depsMap.get($4c8a6d2f80659ed7$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($4c8a6d2f80659ed7$var$isMap(target)) add2(depsMap.get($4c8a6d2f80659ed7$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $4c8a6d2f80659ed7$var$isNonTrackableKeys = /* @__PURE__ */ $4c8a6d2f80659ed7$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $4c8a6d2f80659ed7$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($4c8a6d2f80659ed7$var$isSymbol));
var $4c8a6d2f80659ed7$var$get2 = /* @__PURE__ */ $4c8a6d2f80659ed7$var$createGetter();
var $4c8a6d2f80659ed7$var$readonlyGet = /* @__PURE__ */ $4c8a6d2f80659ed7$var$createGetter(true);
var $4c8a6d2f80659ed7$var$arrayInstrumentations = /* @__PURE__ */ $4c8a6d2f80659ed7$var$createArrayInstrumentations();
function $4c8a6d2f80659ed7$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $4c8a6d2f80659ed7$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$4c8a6d2f80659ed7$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($4c8a6d2f80659ed7$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $4c8a6d2f80659ed7$var$pauseTracking();
            const res = $4c8a6d2f80659ed7$var$toRaw(this)[key].apply(this, args);
            $4c8a6d2f80659ed7$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $4c8a6d2f80659ed7$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $4c8a6d2f80659ed7$var$shallowReadonlyMap : $4c8a6d2f80659ed7$var$readonlyMap : shallow ? $4c8a6d2f80659ed7$var$shallowReactiveMap : $4c8a6d2f80659ed7$var$reactiveMap).get(target)) return target;
        const targetIsArray = $4c8a6d2f80659ed7$var$isArray(target);
        if (!isReadonly && targetIsArray && $4c8a6d2f80659ed7$var$hasOwn($4c8a6d2f80659ed7$var$arrayInstrumentations, key)) return Reflect.get($4c8a6d2f80659ed7$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($4c8a6d2f80659ed7$var$isSymbol(key) ? $4c8a6d2f80659ed7$var$builtInSymbols.has(key) : $4c8a6d2f80659ed7$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $4c8a6d2f80659ed7$var$track(target, "get", key);
        if (shallow) return res;
        if ($4c8a6d2f80659ed7$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$4c8a6d2f80659ed7$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($4c8a6d2f80659ed7$var$isObject(res)) return isReadonly ? $4c8a6d2f80659ed7$var$readonly(res) : $4c8a6d2f80659ed7$var$reactive2(res);
        return res;
    };
}
var $4c8a6d2f80659ed7$var$set2 = /* @__PURE__ */ $4c8a6d2f80659ed7$var$createSetter();
function $4c8a6d2f80659ed7$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $4c8a6d2f80659ed7$var$toRaw(value);
            oldValue = $4c8a6d2f80659ed7$var$toRaw(oldValue);
            if (!$4c8a6d2f80659ed7$var$isArray(target) && $4c8a6d2f80659ed7$var$isRef(oldValue) && !$4c8a6d2f80659ed7$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $4c8a6d2f80659ed7$var$isArray(target) && $4c8a6d2f80659ed7$var$isIntegerKey(key) ? Number(key) < target.length : $4c8a6d2f80659ed7$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $4c8a6d2f80659ed7$var$toRaw(receiver)) {
            if (!hadKey) $4c8a6d2f80659ed7$var$trigger(target, "add", key, value);
            else if ($4c8a6d2f80659ed7$var$hasChanged(value, oldValue)) $4c8a6d2f80659ed7$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $4c8a6d2f80659ed7$var$deleteProperty(target, key) {
    const hadKey = $4c8a6d2f80659ed7$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $4c8a6d2f80659ed7$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $4c8a6d2f80659ed7$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$4c8a6d2f80659ed7$var$isSymbol(key) || !$4c8a6d2f80659ed7$var$builtInSymbols.has(key)) $4c8a6d2f80659ed7$var$track(target, "has", key);
    return result;
}
function $4c8a6d2f80659ed7$var$ownKeys(target) {
    $4c8a6d2f80659ed7$var$track(target, "iterate", $4c8a6d2f80659ed7$var$isArray(target) ? "length" : $4c8a6d2f80659ed7$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $4c8a6d2f80659ed7$var$mutableHandlers = {
    get: $4c8a6d2f80659ed7$var$get2,
    set: $4c8a6d2f80659ed7$var$set2,
    deleteProperty: $4c8a6d2f80659ed7$var$deleteProperty,
    has: $4c8a6d2f80659ed7$var$has,
    ownKeys: $4c8a6d2f80659ed7$var$ownKeys
};
var $4c8a6d2f80659ed7$var$readonlyHandlers = {
    get: $4c8a6d2f80659ed7$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $4c8a6d2f80659ed7$var$toReactive = (value)=>$4c8a6d2f80659ed7$var$isObject(value) ? $4c8a6d2f80659ed7$var$reactive2(value) : value;
var $4c8a6d2f80659ed7$var$toReadonly = (value)=>$4c8a6d2f80659ed7$var$isObject(value) ? $4c8a6d2f80659ed7$var$readonly(value) : value;
var $4c8a6d2f80659ed7$var$toShallow = (value)=>value;
var $4c8a6d2f80659ed7$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $4c8a6d2f80659ed7$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $4c8a6d2f80659ed7$var$toRaw(target);
    const rawKey = $4c8a6d2f80659ed7$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $4c8a6d2f80659ed7$var$track(rawTarget, "get", key);
    !isReadonly && $4c8a6d2f80659ed7$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $4c8a6d2f80659ed7$var$getProto(rawTarget);
    const wrap = isShallow ? $4c8a6d2f80659ed7$var$toShallow : isReadonly ? $4c8a6d2f80659ed7$var$toReadonly : $4c8a6d2f80659ed7$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $4c8a6d2f80659ed7$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $4c8a6d2f80659ed7$var$toRaw(target);
    const rawKey = $4c8a6d2f80659ed7$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $4c8a6d2f80659ed7$var$track(rawTarget, "has", key);
    !isReadonly && $4c8a6d2f80659ed7$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $4c8a6d2f80659ed7$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $4c8a6d2f80659ed7$var$track($4c8a6d2f80659ed7$var$toRaw(target), "iterate", $4c8a6d2f80659ed7$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $4c8a6d2f80659ed7$var$add(value) {
    value = $4c8a6d2f80659ed7$var$toRaw(value);
    const target = $4c8a6d2f80659ed7$var$toRaw(this);
    const proto = $4c8a6d2f80659ed7$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $4c8a6d2f80659ed7$var$trigger(target, "add", value, value);
    }
    return this;
}
function $4c8a6d2f80659ed7$var$set$1(key, value) {
    value = $4c8a6d2f80659ed7$var$toRaw(value);
    const target = $4c8a6d2f80659ed7$var$toRaw(this);
    const { has: has2, get: get3 } = $4c8a6d2f80659ed7$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $4c8a6d2f80659ed7$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $4c8a6d2f80659ed7$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $4c8a6d2f80659ed7$var$trigger(target, "add", key, value);
    else if ($4c8a6d2f80659ed7$var$hasChanged(value, oldValue)) $4c8a6d2f80659ed7$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $4c8a6d2f80659ed7$var$deleteEntry(key) {
    const target = $4c8a6d2f80659ed7$var$toRaw(this);
    const { has: has2, get: get3 } = $4c8a6d2f80659ed7$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $4c8a6d2f80659ed7$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $4c8a6d2f80659ed7$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $4c8a6d2f80659ed7$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $4c8a6d2f80659ed7$var$clear() {
    const target = $4c8a6d2f80659ed7$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $4c8a6d2f80659ed7$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $4c8a6d2f80659ed7$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $4c8a6d2f80659ed7$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $4c8a6d2f80659ed7$var$toRaw(target);
        const wrap = isShallow ? $4c8a6d2f80659ed7$var$toShallow : isReadonly ? $4c8a6d2f80659ed7$var$toReadonly : $4c8a6d2f80659ed7$var$toReactive;
        !isReadonly && $4c8a6d2f80659ed7$var$track(rawTarget, "iterate", $4c8a6d2f80659ed7$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $4c8a6d2f80659ed7$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $4c8a6d2f80659ed7$var$toRaw(target);
        const targetIsMap = $4c8a6d2f80659ed7$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $4c8a6d2f80659ed7$var$toShallow : isReadonly ? $4c8a6d2f80659ed7$var$toReadonly : $4c8a6d2f80659ed7$var$toReactive;
        !isReadonly && $4c8a6d2f80659ed7$var$track(rawTarget, "iterate", isKeyOnly ? $4c8a6d2f80659ed7$var$MAP_KEY_ITERATE_KEY : $4c8a6d2f80659ed7$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $4c8a6d2f80659ed7$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$4c8a6d2f80659ed7$var$capitalize(type)} operation ${key}failed: target is readonly.`, $4c8a6d2f80659ed7$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $4c8a6d2f80659ed7$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $4c8a6d2f80659ed7$var$get$1(this, key);
        },
        get size () {
            return $4c8a6d2f80659ed7$var$size(this);
        },
        has: $4c8a6d2f80659ed7$var$has$1,
        add: $4c8a6d2f80659ed7$var$add,
        set: $4c8a6d2f80659ed7$var$set$1,
        delete: $4c8a6d2f80659ed7$var$deleteEntry,
        clear: $4c8a6d2f80659ed7$var$clear,
        forEach: $4c8a6d2f80659ed7$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $4c8a6d2f80659ed7$var$get$1(this, key, false, true);
        },
        get size () {
            return $4c8a6d2f80659ed7$var$size(this);
        },
        has: $4c8a6d2f80659ed7$var$has$1,
        add: $4c8a6d2f80659ed7$var$add,
        set: $4c8a6d2f80659ed7$var$set$1,
        delete: $4c8a6d2f80659ed7$var$deleteEntry,
        clear: $4c8a6d2f80659ed7$var$clear,
        forEach: $4c8a6d2f80659ed7$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $4c8a6d2f80659ed7$var$get$1(this, key, true);
        },
        get size () {
            return $4c8a6d2f80659ed7$var$size(this, true);
        },
        has (key) {
            return $4c8a6d2f80659ed7$var$has$1.call(this, key, true);
        },
        add: $4c8a6d2f80659ed7$var$createReadonlyMethod("add"),
        set: $4c8a6d2f80659ed7$var$createReadonlyMethod("set"),
        delete: $4c8a6d2f80659ed7$var$createReadonlyMethod("delete"),
        clear: $4c8a6d2f80659ed7$var$createReadonlyMethod("clear"),
        forEach: $4c8a6d2f80659ed7$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $4c8a6d2f80659ed7$var$get$1(this, key, true, true);
        },
        get size () {
            return $4c8a6d2f80659ed7$var$size(this, true);
        },
        has (key) {
            return $4c8a6d2f80659ed7$var$has$1.call(this, key, true);
        },
        add: $4c8a6d2f80659ed7$var$createReadonlyMethod("add"),
        set: $4c8a6d2f80659ed7$var$createReadonlyMethod("set"),
        delete: $4c8a6d2f80659ed7$var$createReadonlyMethod("delete"),
        clear: $4c8a6d2f80659ed7$var$createReadonlyMethod("clear"),
        forEach: $4c8a6d2f80659ed7$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $4c8a6d2f80659ed7$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $4c8a6d2f80659ed7$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $4c8a6d2f80659ed7$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $4c8a6d2f80659ed7$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$4c8a6d2f80659ed7$var$mutableInstrumentations, $4c8a6d2f80659ed7$var$readonlyInstrumentations, $4c8a6d2f80659ed7$var$shallowInstrumentations, $4c8a6d2f80659ed7$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $4c8a6d2f80659ed7$var$createInstrumentations();
function $4c8a6d2f80659ed7$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $4c8a6d2f80659ed7$var$shallowReadonlyInstrumentations : $4c8a6d2f80659ed7$var$shallowInstrumentations : isReadonly ? $4c8a6d2f80659ed7$var$readonlyInstrumentations : $4c8a6d2f80659ed7$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($4c8a6d2f80659ed7$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $4c8a6d2f80659ed7$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $4c8a6d2f80659ed7$var$createInstrumentationGetter(false, false)
};
var $4c8a6d2f80659ed7$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $4c8a6d2f80659ed7$var$createInstrumentationGetter(true, false)
};
function $4c8a6d2f80659ed7$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $4c8a6d2f80659ed7$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $4c8a6d2f80659ed7$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $4c8a6d2f80659ed7$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $4c8a6d2f80659ed7$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $4c8a6d2f80659ed7$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $4c8a6d2f80659ed7$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $4c8a6d2f80659ed7$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $4c8a6d2f80659ed7$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $4c8a6d2f80659ed7$var$targetTypeMap($4c8a6d2f80659ed7$var$toRawType(value));
}
function $4c8a6d2f80659ed7$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $4c8a6d2f80659ed7$var$createReactiveObject(target, false, $4c8a6d2f80659ed7$var$mutableHandlers, $4c8a6d2f80659ed7$var$mutableCollectionHandlers, $4c8a6d2f80659ed7$var$reactiveMap);
}
function $4c8a6d2f80659ed7$var$readonly(target) {
    return $4c8a6d2f80659ed7$var$createReactiveObject(target, true, $4c8a6d2f80659ed7$var$readonlyHandlers, $4c8a6d2f80659ed7$var$readonlyCollectionHandlers, $4c8a6d2f80659ed7$var$readonlyMap);
}
function $4c8a6d2f80659ed7$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$4c8a6d2f80659ed7$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $4c8a6d2f80659ed7$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $4c8a6d2f80659ed7$var$toRaw(observed) {
    return observed && $4c8a6d2f80659ed7$var$toRaw(observed["__v_raw"]) || observed;
}
function $4c8a6d2f80659ed7$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$4c8a6d2f80659ed7$var$magic("nextTick", ()=>$4c8a6d2f80659ed7$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$4c8a6d2f80659ed7$var$magic("dispatch", (el)=>$4c8a6d2f80659ed7$var$dispatch.bind($4c8a6d2f80659ed7$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$4c8a6d2f80659ed7$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $4c8a6d2f80659ed7$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$4c8a6d2f80659ed7$var$magic("store", $4c8a6d2f80659ed7$var$getStores);
// packages/alpinejs/src/magics/$data.js
$4c8a6d2f80659ed7$var$magic("data", (el)=>$4c8a6d2f80659ed7$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$4c8a6d2f80659ed7$var$magic("root", (el)=>$4c8a6d2f80659ed7$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$4c8a6d2f80659ed7$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $4c8a6d2f80659ed7$var$mergeProxies($4c8a6d2f80659ed7$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $4c8a6d2f80659ed7$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $4c8a6d2f80659ed7$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $4c8a6d2f80659ed7$var$globalIdMemo = {};
function $4c8a6d2f80659ed7$var$findAndIncrementId(name) {
    if (!$4c8a6d2f80659ed7$var$globalIdMemo[name]) $4c8a6d2f80659ed7$var$globalIdMemo[name] = 0;
    return ++$4c8a6d2f80659ed7$var$globalIdMemo[name];
}
function $4c8a6d2f80659ed7$var$closestIdRoot(el, name) {
    return $4c8a6d2f80659ed7$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $4c8a6d2f80659ed7$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $4c8a6d2f80659ed7$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$4c8a6d2f80659ed7$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $4c8a6d2f80659ed7$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $4c8a6d2f80659ed7$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $4c8a6d2f80659ed7$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$4c8a6d2f80659ed7$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $4c8a6d2f80659ed7$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$4c8a6d2f80659ed7$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$4c8a6d2f80659ed7$var$warnMissingPluginMagic("Focus", "focus", "focus");
$4c8a6d2f80659ed7$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $4c8a6d2f80659ed7$var$warnMissingPluginMagic(name, magicName, slug) {
    $4c8a6d2f80659ed7$var$magic(magicName, (el)=>$4c8a6d2f80659ed7$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$4c8a6d2f80659ed7$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $4c8a6d2f80659ed7$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$4c8a6d2f80659ed7$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $4c8a6d2f80659ed7$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $4c8a6d2f80659ed7$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $4c8a6d2f80659ed7$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $4c8a6d2f80659ed7$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $4c8a6d2f80659ed7$var$skipDuringClone(()=>{
            $4c8a6d2f80659ed7$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $4c8a6d2f80659ed7$var$getTarget(expression);
        $4c8a6d2f80659ed7$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$4c8a6d2f80659ed7$var$mutateDom(()=>{
            clone2.remove();
            $4c8a6d2f80659ed7$var$destroyTree(clone2);
        }));
});
var $4c8a6d2f80659ed7$var$teleportContainerDuringClone = document.createElement("div");
function $4c8a6d2f80659ed7$var$getTarget(expression) {
    let target = $4c8a6d2f80659ed7$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $4c8a6d2f80659ed7$var$teleportContainerDuringClone;
    })();
    if (!target) $4c8a6d2f80659ed7$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $4c8a6d2f80659ed7$var$handler = ()=>{};
$4c8a6d2f80659ed7$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$4c8a6d2f80659ed7$var$directive("ignore", $4c8a6d2f80659ed7$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$4c8a6d2f80659ed7$var$directive("effect", $4c8a6d2f80659ed7$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($4c8a6d2f80659ed7$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $4c8a6d2f80659ed7$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $4c8a6d2f80659ed7$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $4c8a6d2f80659ed7$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $4c8a6d2f80659ed7$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $4c8a6d2f80659ed7$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $4c8a6d2f80659ed7$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $4c8a6d2f80659ed7$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($4c8a6d2f80659ed7$var$isKeyEvent(event) || $4c8a6d2f80659ed7$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($4c8a6d2f80659ed7$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $4c8a6d2f80659ed7$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $4c8a6d2f80659ed7$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $4c8a6d2f80659ed7$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $4c8a6d2f80659ed7$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $4c8a6d2f80659ed7$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $4c8a6d2f80659ed7$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $4c8a6d2f80659ed7$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $4c8a6d2f80659ed7$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $4c8a6d2f80659ed7$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $4c8a6d2f80659ed7$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($4c8a6d2f80659ed7$var$isClickEvent(e.type)) return false;
            if ($4c8a6d2f80659ed7$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $4c8a6d2f80659ed7$var$keyToModifiers(key) {
    if (!key) return [];
    key = $4c8a6d2f80659ed7$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$4c8a6d2f80659ed7$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $4c8a6d2f80659ed7$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $4c8a6d2f80659ed7$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $4c8a6d2f80659ed7$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $4c8a6d2f80659ed7$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($4c8a6d2f80659ed7$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $4c8a6d2f80659ed7$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($4c8a6d2f80659ed7$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($4c8a6d2f80659ed7$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($4c8a6d2f80659ed7$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($4c8a6d2f80659ed7$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!el.form._x_pendingModelUpdates) el.form._x_pendingModelUpdates = [];
                el.form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>el.form._x_pendingModelUpdates.splice(el.form._x_pendingModelUpdates.indexOf(syncCallback), 1));
            }
        }
        if (hasEnterModifier) listeners.push($4c8a6d2f80659ed7$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $4c8a6d2f80659ed7$var$on(el, event, modifiers, (e)=>{
            setValue($4c8a6d2f80659ed7$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $4c8a6d2f80659ed7$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($4c8a6d2f80659ed7$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $4c8a6d2f80659ed7$var$on(el.form, "reset", [], (e)=>{
            $4c8a6d2f80659ed7$var$nextTick(()=>el._x_model && el._x_model.set($4c8a6d2f80659ed7$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $4c8a6d2f80659ed7$var$mutateDom(()=>$4c8a6d2f80659ed7$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $4c8a6d2f80659ed7$var$getInputValue(el, modifiers, event, currentValue) {
    return $4c8a6d2f80659ed7$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($4c8a6d2f80659ed7$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $4c8a6d2f80659ed7$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $4c8a6d2f80659ed7$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$4c8a6d2f80659ed7$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $4c8a6d2f80659ed7$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $4c8a6d2f80659ed7$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($4c8a6d2f80659ed7$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $4c8a6d2f80659ed7$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $4c8a6d2f80659ed7$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $4c8a6d2f80659ed7$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $4c8a6d2f80659ed7$var$isNumeric2(number) ? number : rawValue;
}
function $4c8a6d2f80659ed7$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $4c8a6d2f80659ed7$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $4c8a6d2f80659ed7$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$4c8a6d2f80659ed7$var$directive("cloak", (el)=>queueMicrotask(()=>$4c8a6d2f80659ed7$var$mutateDom(()=>el.removeAttribute($4c8a6d2f80659ed7$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$4c8a6d2f80659ed7$var$addInitSelector(()=>`[${$4c8a6d2f80659ed7$var$prefix("init")}]`);
$4c8a6d2f80659ed7$var$directive("init", $4c8a6d2f80659ed7$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$4c8a6d2f80659ed7$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$4c8a6d2f80659ed7$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $4c8a6d2f80659ed7$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$4c8a6d2f80659ed7$var$mapAttributes($4c8a6d2f80659ed7$var$startingWith(":", $4c8a6d2f80659ed7$var$into($4c8a6d2f80659ed7$var$prefix("bind:"))));
var $4c8a6d2f80659ed7$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $4c8a6d2f80659ed7$var$injectBindingProviders(bindingProviders);
        let getBindings = $4c8a6d2f80659ed7$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $4c8a6d2f80659ed7$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $4c8a6d2f80659ed7$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $4c8a6d2f80659ed7$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $4c8a6d2f80659ed7$var$mutateDom(()=>$4c8a6d2f80659ed7$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$4c8a6d2f80659ed7$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$4c8a6d2f80659ed7$var$directive("bind", $4c8a6d2f80659ed7$var$handler2);
function $4c8a6d2f80659ed7$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$4c8a6d2f80659ed7$var$addRootSelector(()=>`[${$4c8a6d2f80659ed7$var$prefix("data")}]`);
$4c8a6d2f80659ed7$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($4c8a6d2f80659ed7$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $4c8a6d2f80659ed7$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $4c8a6d2f80659ed7$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $4c8a6d2f80659ed7$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $4c8a6d2f80659ed7$var$injectMagics(data2, el);
    let reactiveData = $4c8a6d2f80659ed7$var$reactive(data2);
    $4c8a6d2f80659ed7$var$initInterceptors(reactiveData);
    let undo = $4c8a6d2f80659ed7$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $4c8a6d2f80659ed7$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $4c8a6d2f80659ed7$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$4c8a6d2f80659ed7$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $4c8a6d2f80659ed7$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$4c8a6d2f80659ed7$var$isCloning) return false;
    if ($4c8a6d2f80659ed7$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$4c8a6d2f80659ed7$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $4c8a6d2f80659ed7$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $4c8a6d2f80659ed7$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $4c8a6d2f80659ed7$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $4c8a6d2f80659ed7$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$4c8a6d2f80659ed7$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $4c8a6d2f80659ed7$var$parseForExpression(expression);
    let evaluateItems = $4c8a6d2f80659ed7$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $4c8a6d2f80659ed7$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$4c8a6d2f80659ed7$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$4c8a6d2f80659ed7$var$mutateDom(()=>{
                $4c8a6d2f80659ed7$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $4c8a6d2f80659ed7$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($4c8a6d2f80659ed7$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $4c8a6d2f80659ed7$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $4c8a6d2f80659ed7$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $4c8a6d2f80659ed7$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $4c8a6d2f80659ed7$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                $4c8a6d2f80659ed7$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                if (!elForSpot) $4c8a6d2f80659ed7$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $4c8a6d2f80659ed7$var$reactive(scope2);
            $4c8a6d2f80659ed7$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                lastEl.after(clone2);
                $4c8a6d2f80659ed7$var$skipDuringClone(()=>$4c8a6d2f80659ed7$var$initTree(clone2))();
            });
            if (typeof key === "object") $4c8a6d2f80659ed7$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $4c8a6d2f80659ed7$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $4c8a6d2f80659ed7$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $4c8a6d2f80659ed7$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $4c8a6d2f80659ed7$var$handler3() {}
$4c8a6d2f80659ed7$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $4c8a6d2f80659ed7$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$4c8a6d2f80659ed7$var$directive("ref", $4c8a6d2f80659ed7$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$4c8a6d2f80659ed7$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $4c8a6d2f80659ed7$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $4c8a6d2f80659ed7$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $4c8a6d2f80659ed7$var$addScopeToNode(clone2, {}, el);
        $4c8a6d2f80659ed7$var$mutateDom(()=>{
            el.after(clone2);
            $4c8a6d2f80659ed7$var$skipDuringClone(()=>$4c8a6d2f80659ed7$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $4c8a6d2f80659ed7$var$mutateDom(()=>{
                $4c8a6d2f80659ed7$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$4c8a6d2f80659ed7$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$4c8a6d2f80659ed7$var$setIdRoot(el, name));
});
$4c8a6d2f80659ed7$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$4c8a6d2f80659ed7$var$mapAttributes($4c8a6d2f80659ed7$var$startingWith("@", $4c8a6d2f80659ed7$var$into($4c8a6d2f80659ed7$var$prefix("on:"))));
$4c8a6d2f80659ed7$var$directive("on", $4c8a6d2f80659ed7$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $4c8a6d2f80659ed7$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $4c8a6d2f80659ed7$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$4c8a6d2f80659ed7$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$4c8a6d2f80659ed7$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$4c8a6d2f80659ed7$var$warnMissingPluginDirective("Focus", "trap", "focus");
$4c8a6d2f80659ed7$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $4c8a6d2f80659ed7$var$warnMissingPluginDirective(name, directiveName, slug) {
    $4c8a6d2f80659ed7$var$directive(directiveName, (el)=>$4c8a6d2f80659ed7$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$4c8a6d2f80659ed7$var$alpine_default.setEvaluator($4c8a6d2f80659ed7$var$normalEvaluator);
$4c8a6d2f80659ed7$var$alpine_default.setRawEvaluator($4c8a6d2f80659ed7$var$normalRawEvaluator);
$4c8a6d2f80659ed7$var$alpine_default.setReactivityEngine({
    reactive: $4c8a6d2f80659ed7$var$reactive2,
    effect: $4c8a6d2f80659ed7$var$effect2,
    release: $4c8a6d2f80659ed7$var$stop,
    raw: $4c8a6d2f80659ed7$var$toRaw
});
var $4c8a6d2f80659ed7$export$b7ee041e4ad2afec = $4c8a6d2f80659ed7$var$alpine_default;
// packages/alpinejs/builds/module.js
var $4c8a6d2f80659ed7$export$2e2bcd8739ae039 = $4c8a6d2f80659ed7$export$b7ee041e4ad2afec;



if (document.querySelector(".js-copy")) (parcelRequire("1Zagj")).then((init)=>init.default());
window.Alpine = (0, $4c8a6d2f80659ed7$export$2e2bcd8739ae039);
const $e934c041b9e1b3c5$var$limeWoodFontStack = "sans-serif";
const $e934c041b9e1b3c5$var$limeWoodPrimaryColor = "#c4d600";
const $e934c041b9e1b3c5$var$limeWoodSecondaryColor = "#292f2c";
const $e934c041b9e1b3c5$var$limeWoodTertiaryColor = "#f9fae2";
const $e934c041b9e1b3c5$var$limeWoodTheme1Foreground = "#c4d600";
const $e934c041b9e1b3c5$var$limeWoodTheme1Background = "#293436";
const $e934c041b9e1b3c5$var$limeWoodTheme2Foreground = "#ffffff";
const $e934c041b9e1b3c5$var$limeWoodTheme2Background = "#293436";
const $e934c041b9e1b3c5$var$limeWoodAddress = "Beaulieu Road, Lyndhurst<br>Hampshire, SO43 7FZ";
const $e934c041b9e1b3c5$var$limeWoodFacebookUrl = "https://www.facebook.com/LimeWoodHotel/";
const $e934c041b9e1b3c5$var$limeWoodFacebookIcon = "img/socials/facebook-c4d600.png";
const $e934c041b9e1b3c5$var$limeWoodXUrl = "https://x.com/limewoodhotel/";
const $e934c041b9e1b3c5$var$limeWoodXIcon = "img/socials/x-c4d600.png";
const $e934c041b9e1b3c5$var$limeWoodInstagramUrl = "https://www.instagram.com/limewoodhotel/";
const $e934c041b9e1b3c5$var$limeWoodInstagramIcon = "img/socials/instagram-c4d600.png";
const $e934c041b9e1b3c5$var$limeWoodYouTubeIcon = "img/socials/youtube-c4d600.png";
const $e934c041b9e1b3c5$var$limeWoodCharityPartnersUrl = "https://www.limewoodhotel.co.uk/about-us";
const $e934c041b9e1b3c5$var$limeWoodAwardBannerImage = "img/custom/conde-nast-traveller-triple-crown.png";
const $e934c041b9e1b3c5$var$limeWoodAwardBannerUrl = "https://www.limewoodhotel.co.uk/press-room";
const $e934c041b9e1b3c5$var$personalFacebookIcon = "img/socials/facebook-000000.png";
const $e934c041b9e1b3c5$var$personalInstagramIcon = "img/socials/instagram-000000.png";
const $e934c041b9e1b3c5$var$personalXIcon = "img/socials/x-000000.png";
const $e934c041b9e1b3c5$var$defaultBrand = {
    fontStack: $e934c041b9e1b3c5$var$limeWoodFontStack,
    parent: "lime-wood-group",
    id: "lime-wood-group",
    name: "Lime Wood Group",
    url: "https://www.limewoodhotel.co.uk",
    cleanUrl: "www.limewoodhotel.co.uk",
    address: "Lime Wood Group Ltd<br>Hawkslease, Chapel Lane<br>Lyndhurst<br>SO43 7FG",
    logo: "img/brands/limewood-portetta.png",
    primaryColor: $e934c041b9e1b3c5$var$limeWoodPrimaryColor,
    secondaryColor: $e934c041b9e1b3c5$var$limeWoodSecondaryColor,
    tertiaryColor: $e934c041b9e1b3c5$var$limeWoodTertiaryColor,
    theme1Foreground: $e934c041b9e1b3c5$var$limeWoodTheme1Foreground,
    theme1Background: $e934c041b9e1b3c5$var$limeWoodTheme1Background,
    theme2Foreground: $e934c041b9e1b3c5$var$limeWoodTheme2Foreground,
    theme2Background: $e934c041b9e1b3c5$var$limeWoodTheme2Background,
    theme3Foreground: "#ffffff",
    theme3Background: "#4f868e",
    theme4Foreground: "#ffffff",
    theme4Background: "#ef3340",
    theme5Foreground: "#ffffff",
    theme5Background: "#a0b5cf",
    facebookUrl: $e934c041b9e1b3c5$var$limeWoodFacebookUrl,
    facebookIcon: $e934c041b9e1b3c5$var$limeWoodFacebookIcon,
    xUrl: $e934c041b9e1b3c5$var$limeWoodXUrl,
    xIcon: $e934c041b9e1b3c5$var$limeWoodXIcon,
    instagramUrl: $e934c041b9e1b3c5$var$limeWoodInstagramUrl,
    instagramIcon: $e934c041b9e1b3c5$var$limeWoodInstagramIcon,
    youTubeIcon: $e934c041b9e1b3c5$var$limeWoodYouTubeIcon,
    charityPartnersUrl: $e934c041b9e1b3c5$var$limeWoodCharityPartnersUrl,
    awardBannerImage: $e934c041b9e1b3c5$var$limeWoodAwardBannerImage,
    awardBannerUrl: $e934c041b9e1b3c5$var$limeWoodAwardBannerUrl,
    personalFacebookIcon: $e934c041b9e1b3c5$var$personalFacebookIcon,
    personalInstagramIcon: $e934c041b9e1b3c5$var$personalInstagramIcon,
    personalXIcon: $e934c041b9e1b3c5$var$personalXIcon
};
const $e934c041b9e1b3c5$var$allBrands = [
    $e934c041b9e1b3c5$var$defaultBrand,
    {
        fontStack: $e934c041b9e1b3c5$var$limeWoodFontStack,
        parent: "lime-wood-portetta-hhco",
        id: "lime-wood-portetta-hhco",
        name: "Lime Wood / Portetta / HH&Co",
        url: "https://www.limewoodhotel.co.uk",
        cleanUrl: "www.limewoodhotel.co.uk",
        logo: "img/brands/limewood-hhco.png",
        brandLogo: "img/brands/limewood-hhco-portetta-brand.png",
        primaryColor: $e934c041b9e1b3c5$var$limeWoodPrimaryColor,
        secondaryColor: $e934c041b9e1b3c5$var$limeWoodSecondaryColor,
        tertiaryColor: $e934c041b9e1b3c5$var$limeWoodTertiaryColor,
        theme1Foreground: $e934c041b9e1b3c5$var$limeWoodTheme1Foreground,
        theme1Background: $e934c041b9e1b3c5$var$limeWoodTheme1Background,
        theme2Foreground: $e934c041b9e1b3c5$var$limeWoodTheme2Foreground,
        theme2Background: $e934c041b9e1b3c5$var$limeWoodTheme2Background,
        facebookUrl: $e934c041b9e1b3c5$var$limeWoodFacebookUrl,
        facebookIcon: $e934c041b9e1b3c5$var$limeWoodFacebookIcon,
        xUrl: $e934c041b9e1b3c5$var$limeWoodXUrl,
        xIcon: $e934c041b9e1b3c5$var$limeWoodXIcon,
        instagramUrl: $e934c041b9e1b3c5$var$limeWoodInstagramUrl,
        instagramIcon: $e934c041b9e1b3c5$var$limeWoodInstagramIcon,
        youTubeIcon: $e934c041b9e1b3c5$var$limeWoodYouTubeIcon,
        charityPartnersUrl: $e934c041b9e1b3c5$var$limeWoodCharityPartnersUrl,
        awardBannerImage: $e934c041b9e1b3c5$var$limeWoodAwardBannerImage,
        awardBannerUrl: $e934c041b9e1b3c5$var$limeWoodAwardBannerUrl,
        personalFacebookIcon: $e934c041b9e1b3c5$var$personalFacebookIcon,
        personalInstagramIcon: $e934c041b9e1b3c5$var$personalInstagramIcon,
        personalXIcon: $e934c041b9e1b3c5$var$personalXIcon,
        secondaryBrandFontStack: "sans-serif",
        secondaryBrandName: "Portetta",
        secondaryBrandUrl: "https://www.portetta.com",
        secondaryBrandCleanUrl: "www.portetta.com",
        secondaryBrandLogo: "img/brands/portetta.png",
        secondaryBrandColor: "#a0b5cf",
        secondaryBrandFacebookUrl: "https://www.facebook.com/pages/Portetta/290030524360027",
        secondaryBrandFacebookIcon: "img/socials/facebook-a0b5cf.png",
        secondaryBrandXUrl: "https://x.com/portetta",
        secondaryBrandXIcon: "img/socials/x-a0b5cf.png",
        secondaryBrandInstagramUrl: "https://www.instagram.com/portettahotel/",
        secondaryBrandInstagramIcon: "img/socials/instagram-a0b5cf.png"
    },
    {
        fontStack: $e934c041b9e1b3c5$var$limeWoodFontStack,
        parent: "lime-wood-group",
        id: "lime-wood",
        name: "Lime Wood",
        url: "https://www.limewoodhotel.co.uk",
        cleanUrl: "www.limewoodhotel.co.uk",
        address: $e934c041b9e1b3c5$var$limeWoodAddress,
        logo: "img/brands/limewood.png",
        primaryColor: $e934c041b9e1b3c5$var$limeWoodPrimaryColor,
        secondaryColor: $e934c041b9e1b3c5$var$limeWoodSecondaryColor,
        tertiaryColor: $e934c041b9e1b3c5$var$limeWoodTertiaryColor,
        theme1Foreground: $e934c041b9e1b3c5$var$limeWoodTheme1Foreground,
        theme1Background: $e934c041b9e1b3c5$var$limeWoodTheme1Background,
        theme2Foreground: $e934c041b9e1b3c5$var$limeWoodTheme2Foreground,
        theme2Background: $e934c041b9e1b3c5$var$limeWoodTheme2Background,
        facebookUrl: $e934c041b9e1b3c5$var$limeWoodFacebookUrl,
        facebookIcon: $e934c041b9e1b3c5$var$limeWoodFacebookIcon,
        xUrl: $e934c041b9e1b3c5$var$limeWoodXUrl,
        xIcon: $e934c041b9e1b3c5$var$limeWoodXIcon,
        instagramUrl: $e934c041b9e1b3c5$var$limeWoodInstagramUrl,
        instagramIcon: $e934c041b9e1b3c5$var$limeWoodInstagramIcon,
        youTubeIcon: $e934c041b9e1b3c5$var$limeWoodYouTubeIcon,
        charityPartnersUrl: $e934c041b9e1b3c5$var$limeWoodCharityPartnersUrl,
        awardBannerImage: $e934c041b9e1b3c5$var$limeWoodAwardBannerImage,
        awardBannerUrl: $e934c041b9e1b3c5$var$limeWoodAwardBannerUrl,
        personalFacebookIcon: $e934c041b9e1b3c5$var$personalFacebookIcon,
        personalInstagramIcon: $e934c041b9e1b3c5$var$personalInstagramIcon,
        personalXIcon: $e934c041b9e1b3c5$var$personalXIcon
    },
    {
        fontStack: "sans-serif",
        parent: "herb-house",
        id: "herb-house",
        name: "Herb House",
        url: "https://herbhousespa.co.uk",
        cleanUrl: "herbhousespa.co.uk",
        address: $e934c041b9e1b3c5$var$limeWoodAddress,
        logo: "img/brands/herb-house.png",
        primaryColor: "#64ccc9",
        secondaryColor: "#4f868e",
        tertiaryColor: "#4f868e",
        theme1Foreground: "#ffffff",
        theme1Background: "#4f868e",
        theme2Foreground: "#64ccc9",
        theme2Background: "#293436",
        facebookUrl: "https://www.facebook.com/LimeWoodHotel/",
        facebookIcon: "img/socials/facebook-64ccc9.png",
        xUrl: "https://x.com/limewoodhotel/",
        xIcon: "img/socials/x-64ccc9.png",
        instagramUrl: "https://www.instagram.com/limewoodhotel/",
        instagramIcon: "img/socials/instagram-64ccc9.png",
        youTubeIcon: "img/socials/youtube-64ccc9.png",
        charityPartnersUrl: $e934c041b9e1b3c5$var$limeWoodCharityPartnersUrl,
        personalFacebookIcon: $e934c041b9e1b3c5$var$personalFacebookIcon,
        personalInstagramIcon: $e934c041b9e1b3c5$var$personalInstagramIcon,
        personalXIcon: $e934c041b9e1b3c5$var$personalXIcon
    },
    {
        fontStack: "sans-serif",
        parent: "hartnett-holder-co",
        id: "hartnett-holder-co",
        name: "Hartnett Holder & Co",
        url: "https://hartnettholderandco.com",
        cleanUrl: "hartnettholderandco.com",
        address: $e934c041b9e1b3c5$var$limeWoodAddress,
        logo: "img/brands/hhco.png",
        brandLogo: "img/brands/hhco-brand.png",
        primaryColor: "#ef3340",
        secondaryColor: "#9a9a9a",
        tertiaryColor: "#9a9a9a",
        theme1Foreground: "#ffffff",
        theme1Background: "#ef3340",
        theme2Foreground: "#ffffff",
        theme2Background: "#293436",
        facebookUrl: "https://www.facebook.com/LimeWoodHotel/",
        facebookIcon: "img/socials/facebook-ef3340.png",
        xUrl: "https://x.com/limewoodhotel/",
        xIcon: "img/socials/x-ef3340.png",
        instagramUrl: "https://www.instagram.com/limewoodhotel/",
        instagramIcon: "img/socials/instagram-ef3340.png",
        youTubeIcon: "img/socials/youtube-ef3340.png",
        charityPartnersUrl: $e934c041b9e1b3c5$var$limeWoodCharityPartnersUrl,
        personalFacebookIcon: $e934c041b9e1b3c5$var$personalFacebookIcon,
        personalInstagramIcon: $e934c041b9e1b3c5$var$personalInstagramIcon,
        personalXIcon: $e934c041b9e1b3c5$var$personalXIcon
    },
    {
        fontStack: "sans-serif",
        parent: "portetta",
        id: "portetta",
        name: "Portetta",
        url: "https://www.portetta.com",
        cleanUrl: "www.portetta.com",
        address: "Courchevel Moriond (1650)<br>73120 Saint Bon<br>France",
        logo: "img/brands/portetta.png",
        primaryColor: "#a0b5cf",
        secondaryColor: "#0e2b32",
        tertiaryColor: "#0e2b32",
        theme1Foreground: "#ffffff",
        theme1Background: "#a0b5cf",
        theme2Foreground: "#0e2b32",
        theme2Background: "#ffffff",
        facebookUrl: "https://www.facebook.com/pages/Portetta/290030524360027",
        facebookIcon: "img/socials/facebook-a0b5cf.png",
        xUrl: "https://x.com/portetta",
        xIcon: "img/socials/x-a0b5cf.png",
        instagramUrl: "https://www.instagram.com/portettahotel/",
        instagramIcon: "img/socials/instagram-a0b5cf.png",
        youTubeIcon: "img/socials/youtube-a0b5cf.png",
        charityPartnersUrl: "https://www.portetta.com/en/about-us",
        personalFacebookIcon: $e934c041b9e1b3c5$var$personalFacebookIcon,
        personalInstagramIcon: $e934c041b9e1b3c5$var$personalInstagramIcon,
        personalXIcon: $e934c041b9e1b3c5$var$personalXIcon
    }
];
(0, $4c8a6d2f80659ed7$export$2e2bcd8739ae039).store("brands", {
    current: {
        defaultBrand: $e934c041b9e1b3c5$var$defaultBrand
    },
    items: $e934c041b9e1b3c5$var$allBrands
});
(0, $4c8a6d2f80659ed7$export$2e2bcd8739ae039).start();


//# sourceMappingURL=s.cb57a82c.js.map
